import { z } from 'zod'
import { DEFAULT_ORGANIZATION_SEARCH } from '@/features/master-data/const/legal-entity-list-search.ts'

export const organizationSearchSchema = z.object({
  current: z.coerce.number().int().min(1).catch(DEFAULT_ORGANIZATION_SEARCH.current),
  pageSize: z.coerce.number().int().min(1).max(100).catch(DEFAULT_ORGANIZATION_SEARCH.pageSize),
  id: z.coerce.number().int().positive().optional().catch(undefined),
  keyword: z.string().trim().max(255).optional().catch(undefined),
  operationMode: z.enum(['agent', 'selfOperated']).optional().catch(undefined),
  status: z.enum(['enabled', 'disabled']).optional().catch(undefined)
})

export type OrganizationListSearch = z.infer<typeof organizationSearchSchema>

export { DEFAULT_ORGANIZATION_SEARCH } from '@/features/master-data/const/legal-entity-list-search.ts'
